import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { cn } from '~/styled'

import { NavigationMenuVerticalIcon } from './NavigationMenuVerticalIcon'
import { NavigationMenuVerticalText } from './NavigationMenuVerticalText'

type TNavigationMenuVerticalItemContentProps = React.ComponentProps<'div'>

export const NavigationMenuVerticalItemContent = ({
  children,
  className,
  ...rest
}: TNavigationMenuVerticalItemContentProps): React.JSX.Element => (
  <div className={cn('flex', 'gap-2', 'items-center', className)} {...rest}>
    {
      React.Children.map(children, (child) => {
        if (typeof child === 'string' || typeof child === 'number') {
          return (
            <NavigationMenuVerticalText>{child}</NavigationMenuVerticalText>
          )
        }
        if (
          React.isValidElement<React.ComponentPropsWithoutRef<typeof Icon>>(
            child
          ) &&
          child.type === Icon
        ) {
          return <NavigationMenuVerticalIcon {...child.props} />
        }
        return child
      }) as React.ReactElement<unknown>[]
    }
  </div>
)
